<aside class="fixed md:static inset-y-0 left-0 z-50 h-screen w-64 bg-[#111827] text-white flex flex-col shadow-2xl transition-transform duration-300 transform md:translate-x-0"
       [class.-translate-x-full]="!(menuService.menuOpen$ | async)">

  <div class="h-20 flex flex-col items-center justify-center border-b border-gray-800 px-6 relative">
    <img src="/logo_rms.png" alt="Logo RMS" class="h-10 w-auto mb-1">
    <p class="text-[10px] text-[#ffb31c] uppercase tracking-widest font-bold">Diseño y Construcción</p>
  </div>

  <nav class="flex-1 overflow-y-auto py-6 px-3 space-y-2">
    @for (item of menuItems(); track item.id) {
      <a [routerLink]="item.ruta"
         routerLinkActive="bg-[#ffb31c] text-[#1e3a8a] shadow-lg font-bold translate-x-2"
         [routerLinkActiveOptions]="{exact: false}"
         class="flex items-center gap-4 px-4 py-3 rounded-xl text-gray-400 hover:text-white hover:bg-gray-800 transition-all group cursor-pointer text-sm font-medium">

        <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icono"></path>
        </svg>

        <span class="tracking-wide">{{ item.nombre }}</span>
      </a>
    }
  </nav>


</aside>
